module.exports = __webpack_public_path__ + "static/img/orig_2.cef2d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/orig_2.png
// module id = bDT6
// module chunks = 1